import { IState } from '../../store';

export const selectorShowWarningMessage = (state: IState) => {
  return state.offerData.offer.showWarningMessage;
};
